import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  BOLApiToken_loading: false,
  BOLApiToken_data: null,
  BOLApiToken_error: null,
  BOLApiToken_success: false,
};

const BOLApiTokenSlice = createSlice({
  name: "BOLApiToken",
  initialState,
  reducers: {
    BOLApiTokenInit: (state) => {
      state.BOLApiToken_loading = true;
      state.BOLApiToken_error = null;
      state.BOLApiToken_success = false;
    },
    BOLApiTokenSuccess: (state, action) => {
      state.BOLApiToken_loading = false;
      state.BOLApiToken_data = action.payload;
      state.BOLApiToken_success = true;
    },
    BOLApiTokenFailure: (state, action) => {
      state.BOLApiToken_loading = false;
      state.BOLApiToken_error = action.payload;
      state.BOLApiToken_success = false;
    },
    BOLApiTokenResetState: () => initialState,
  },
});

export const {
  BOLApiTokenInit,
  BOLApiTokenSuccess,
  BOLApiTokenFailure,
  BOLApiTokenResetState,
} = BOLApiTokenSlice.actions;

export default BOLApiTokenSlice.reducer;
